<div class="container-xxl">
    <!-- START NAVBAR -->
    <nav class="navbar navbar-expand-lg navbar-light">
     <div class="container">
       
       <a class="title navbar-brand" href="#"><h1><span class="logo">خَيْرُ</span>كُمْ</h1></a>
       <sub style="cursor: pointer;" class="m-2"  routerLink="/admin">لوحة التحكم</sub>
       <button
         class="navbar-toggler"
         type="button"
         data-toggle="collapse"
         data-target="#navbarSupportedContent"
         aria-controls="navbarSupportedContent"
         aria-expanded="false"
         aria-label="Toggle navigation"
       >
         <span class="navbar-toggler-icon"></span>
       </button>
        
       

       <div class="collapse navbar-collapse" id="navbarSupportedContent">
         <ul class="navbar-nav mr-auto">
          <li class="admin-list nav-item dropdown">
            <a role="button"  class="btn btn-warning ml-4" aria-expanded="false" (click)="getFeedbacks()">
              طلب التقييمات من المشاركين
            </a>
        
        </li> 
          <li class="notification nav-item dropdown" style="cursor: pointer;">
            <a class="" id="navbardrop" data-toggle="dropdown">
              <span class="badge">{{unReadNotifications}}</span><i class="bell fas fa-bell"></i>
            </a>

            <div class="dropdown-menu" > 
              <div class="noti">
                <p> الاشعارات</p>
                <hr>
              </div>             
              <a class="dropdown-item"  *ngFor="let n of adminNotifications">                
                  <p class="d-flex justify-content-between align-items-center">
                    <b  (click)="notificationRead(n._id,n)" [ngClass]="{'text-warning' : !n.isRead}">{{n.message}}</b> &nbsp; &nbsp; &nbsp;
                    <i class="fas fa-times text-danger" (click)="deleteNotification(n._id) "></i> 
                  </p>                                                   
              </a>              
            </div>
           </li>
           
           <li class="messages nav-item dropdown" style="cursor: pointer;">
            <a class="" id="navbardrop" data-toggle="dropdown">
              <span class="badge">{{unReadMessages}}</span><i class="mess fas fa-comment-dots"></i>
            </a>

            <div class="dropdown-menu" > 
              <div class="message">
                <p> الرسائل </p>
                <hr>
              </div>             
              <a class="dropdown-item"  *ngFor="let m of adminMessages">                
                <p class="d-flex justify-content-between align-items-center">
                  <b  (click)="messageRead(m._id,m)" [ngClass]="{'text-warning' : !m.isRead}">{{m.message}}</b> &nbsp; &nbsp; &nbsp;
                  <i class="fas fa-times text-danger" (click)="deleteMessage(m._id) "></i> 
                </p>                                                   
            </a>  
            </div>
           </li>

        <li class="admin-list nav-item dropdown mr-2">
          <a role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="plus fas fa-plus"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-left text-center bg-light" aria-labelledby="userDropdown" >       
            <a class="nav-link d-block" routerLink="/addCategory">إضافة قسم <span class="sr-only">(current)</span></a>
            <a class="nav-link d-block" routerLink="/addCourse">إضافة دورة تدريبية <span class="sr-only">(current)</span></a>
  <!--           <a class="nav-link d-block" routerLink="/addClass">إضافة مجموعة <span class="sr-only">(current)</span></a> -->
            <a class="nav-link d-block" routerLink="/addSession">إضافة حلقة <span class="sr-only">(current)</span></a>
            <a class="nav-link d-block" routerLink="/addRole">إضافة صلاحية <span class="sr-only">(current)</span></a>
            <a class="nav-link d-block" routerLink="/permissionManagement">إدارة الصلاحيات <span class="sr-only">(current)</span></a>
            
          </div>
      </li> 

      

      <li class="nav-item dropdown">
        <a role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img class="img-fluid rounded-circle" src="https://khairokom-uploadfiles.azurewebsites.net/files/newUser.jpg" width="40px">
        </a>
        <div class="dropdown-menu dropdown-menu-left text-center" aria-labelledby="userDropdown" >       
            <a class="dropdown-item" routerLink="/profile/{{currentUserId}}"><b>{{currentUserName}}</b></a>
            <a class="dropdown-item" (click)="logout()" style="cursor: pointer;">تسجيل الخروج</a>                  
        </div>
    </li>
         </ul>         
       </div>
     </div>
   </nav>
   <!-- END NAVBAR -->
   </div>    
